import React from "react";
import a23logo from "../assets/a23_avatar_logo.png";
import close from "../assets/close.png";
import { connect } from "react-redux";
import {
  toggleModalAction,
  getRedeemDetailsAction,
} from "../redux/actions/userAction";
import Loading from "../models/Loading";
import { REDEEM_INFO } from "../Strings";
import { Link } from "react-router-dom";
import { WebToNativeMessage } from "../Common/Utils";
import callUsIcon from "../assets/Redeem-revamp/callUsIcon.svg";
import navarrow from "../assets/back_btn.png";
import { redeemInTime } from "../Redeem/redeemDetails";
import { instantRedeemlevelsAcelevel } from "../Redeem/InstantRedeemLevelsByAceLevel";
import { isTablet, isAndroid } from "react-device-detect";

class RedeemInfo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      btntxt: "Verify",
      token: window.sessionStorage["token"],
      redeemLimits: [],
      errors: {
        message: "",
      },
    };
  }

  componentWillUnmount() {
    document.body.style.overflow = "unset";
  }

  async componentWillMount() {
    //for Dynamic Token
    this.setState({ token: window.sessionStorage["token"] });
    this.setState({ channel: window.sessionStorage["channel"] });
    await this.props.getRedeemDetailsAction(window.sessionStorage["token"]);
    const { redeemData } = this.props.userState;

    console.log("Redeem details::::", redeemData);
    if (redeemData.error) {
      console.log("Redeem details error::::", redeemData.error);
      await this.setState({
        errors: { message: redeemData.error.message },
        isLoading: false,
      });
    } else {
      console.log("Redeem details success::::", redeemData);
      await this.setState({
        redeemLimits: redeemData.redeemLimits,
        isLoading: false,
      });
    }
  }

  async componentDidMount() {
    // document.body.style.overflow = 'hidden';

    this.setState({ token: window.sessionStorage["token"] });
    this.setState({ channel: window.sessionStorage["channel"] });
    await this.props.getRedeemDetailsAction(window.sessionStorage["token"]);
    const { redeemData } = this.props.userState;

    console.log("Redeem details::::", redeemData);
    if (redeemData.error) {
      console.log("Redeem details error::::", redeemData.error);
      await this.setState({
        errors: { message: redeemData.error.message },
        isLoading: false,
      });
    } else {
      console.log("Redeem details success::::", redeemData);
      await this.setState({
        redeemLimits: redeemData.redeemLimits,
        isLoading: false,
      });
    }
  }

  render() {
    return (
      <div
        style={{
          display: "flex",
          background: "white",
          height: "100%",
          width: "100%",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div className="redeemHeader" style={styles.redeemHeader}>
          <img
            className="backBtn"
            src={navarrow}
            style={{ width: "40px", position: "absolute", left: "2%" }}
            onClick={() => {
              this.props.history.goBack();
            }}
            alt="history"
          />
          Withdraw Policy
        </div>
        <div
          style={{
            ...(isTablet
              ? { width: "50%", marginTop: "5%" }
              : { width: "100%", marginTop: "10%" }),
            height: "94%",
          }}
        >
          <div className="flex" style={{ height: "100%" }}>
            <div
              className="relative absolute--fill flex justify-center items-center center left-1 right-1 white w7"
              style={{
                height: "100%",
                backgroundColor: "white",
                flexDirection: "column",
              }}
            >

              <div
                className="center ph3 pa1 flex flex-column white-snow dark-grey"
                style={{ height: "100%" }}
              >
                <div className="db pt0 f6 mt1 ">
                  <div className="w-100 db f6 tc">
                    <p className="fw6 f6 tl primary-blue">
                      {REDEEM_INFO.REDEEM_INFO_TEXT1}
                    </p>
                    <p className="fw4 f7 tl dark-grey">
                      {REDEEM_INFO.REDEEM_INFO_TEXT2}{" "}
                      <a
                        style={{ color: "#007bff" }}
                        href="/termsandconditions/"
                      >
                        {REDEEM_INFO.REDEEM_TERMS_AND_CONDITIONS_TEXT}
                      </a>
                    </p>
                    {/* <p className="tl f7 fw4 dark-grey">
                          To ensure fairplay we review every
                          redeem and in case additional checks
                          are required, it may take longer to process.
                        </p> */}
                    {/* <p className="fw6 f6 tl primary-blue">
                      {REDEEM_INFO.REDEEM_INFO_TEXT3}
                    </p>                    
                    {
                      <div className="RedeemTable">
                        <div className="RedeemTableRowHeader">
                          <span style={{ marginLeft: "2%", width: "30%", textAlign: "center" }}>
                            {REDEEM_INFO.REDEEM_INFO_ACE_LEVEL}
                          </span>
                          <span
                           style={{ marginRight: "2%", width: "30%", textAlign: "center" }}
                           className="prizeRight"
                          >
                            {" "}
                            No. of request/
                            <br />
                            day
                          </span>
                          <span
                            style={{ marginRight: "3%", width: "30%", textAlign: "center" }}
                            className="prizeRight"
                          >
                            {" "}
                            {REDEEM_INFO.REDEEM_INFO_AMOUNT}
                            <br />
                            {REDEEM_INFO.REDEEM_INFO_REQUEST}
                          </span>
                        </div>
                        {redeemInTime.map((listValue, index) => {
                          return (
                            <div
                              className="RedeemTableRow"
                              key={index}
                              style={{
                                borderBottom:
                                  redeemInTime.length == index + 1 && "none",
                                marginRight: "3%",
                              }}
                            >
                              <span className="rowmiddle2">
                                {listValue.aceLevel.charAt(0).toUpperCase() +
                                  listValue.aceLevel.slice(1)}
                              </span>
                              <span className='rowmiddle2'>{listValue.reqPerDay}</span>
                              <span className="rowmiddle2" style={{ marginRight: "3%" }}>
                                ₹ {listValue.maxAmount.toLocaleString()}
                              </span>
                            </div>
                          );
                        })}
                      </div>
                    } */}

                    <p className="fw6 f6 tl primary-blue">
                      We offer below two types of redeem:
                    </p>


                    <p className="fw6 f6 tl primary-blue"> Instant Redeem</p>
                    <p className="tl fw4 f7 dark-grey">
                      {" "}
                      Usually the amount is credited instantly in your bank account.
Subject to fairplay checks, it may take longer to process in case additional checks are required.

                      {/* Usually the amount is credited instantly in your bank account/wallet. In few cases, it may take up to 30 mins based on response time of your bank. */}
                    </p>
                    {/* </li> */}
                    {/* </ul> */}

                    <p className="fw6 f6 tl primary-blue mt2">
                      Instant Withdraw Limits by Ace Level
                    </p>
                    {/* table */}
                    {/* {
                      <div className="RedeemTable">
                        <div className="RedeemTableRowHeader">
                          <span style={{ marginLeft: "2%", width: "30%", textAlign: "center" }}>
                            {REDEEM_INFO.REDEEM_INFO_ACE_LEVEL}
                          </span>
                          <span
                            style={{ marginRight: "2%", width: "30%", textAlign: "center" }}
                            className="prizeRight"
                          >
                            {" "}
                            Instant Redeems
                            <br />
                            per month
                          </span>
                        </div>
                        {instantRedeemlevelsAcelevel.map((listValue, index) => {
                          return (
                            <div
                              className="RedeemTableRow"
                              key={index}
                              style={{
                                borderBottom:
                                  instantRedeemlevelsAcelevel.length ==
                                    index + 1 && "none",
                              }}
                            >
                              <span className="rowmiddle2">
                                {listValue.aceLevel.charAt(0).toUpperCase() +
                                  listValue.aceLevel.slice(1)}
                              </span>
                             
                              <span className="rowmiddle2">
                                {listValue.instantRedeemsPerMonth}
                              </span>
                            </div>
                          );
                        })}
                      </div>
                    }  */}

{
                      <div className="RedeemTable">
                        <div className="RedeemTableRowHeader">
                          <span style={{ marginLeft: "2%", width: "30%", textAlign: "center" }}>
                            {REDEEM_INFO.REDEEM_INFO_ACE_LEVEL}
                          </span>
                          <span
                           style={{ marginRight: "2%", width: "30%", textAlign: "center" }}
                           className="prizeRight"
                          >
                            {" "}
                            Instant Withdraw
                            <br />
                            per month
                          </span>
                          <span
                            style={{ marginRight: "3%", width: "30%", textAlign: "center" }}
                            className="prizeRight"
                          >
                            {" "}
                            {REDEEM_INFO.REDEEM_INFO_AMOUNT}
                            <br />
                            {REDEEM_INFO.REDEEM_INFO_REQUEST}
                          </span>
                        </div>
                        {instantRedeemlevelsAcelevel.map((listValue, index) => {
                          return (
                            <div
                              className="RedeemTableRow"
                              key={index}
                              style={{
                                borderBottom:
                                instantRedeemlevelsAcelevel.length == index + 1 && "none",
                                marginRight: "3%",
                              }}
                            >
                              <span className="rowmiddle2">
                                {listValue.aceLevel.charAt(0).toUpperCase() +
                                  listValue.aceLevel.slice(1)}
                              </span>
                              <span className='rowmiddle2'>{listValue.instantRedeemsPerMonth}</span>
                              <span className="rowmiddle2" style={{ marginRight: "3%" }}>
                                ₹ {listValue.maxAmountPerRequest.toLocaleString()}
                              </span>
                            </div>
                          );
                        })}
                      </div>
                    }

                    

                     <p className="fw6 f6 tl primary-blue">Standard Withdraw</p>

<div className="">
  <p className="tl fw4 f7 dark-grey">
    {" "}
    Withdraw is processed after 24 hours from request time. After 24 hours, subject to fairplay checks, it may take longer to process in case additional checks are required.
    {/* Usually takes longer to credit amount as processing happens via a queue. It may take up to 8 hours based on the number of redeems in queue at the moment. You can cancel the redeem within that time. */}
  </p>
</div>
<p className="fw6 f6 tl primary-blue">
                      {REDEEM_INFO.REDEEM_INFO_TEXT3}
                    </p>  
{
                      <div className="RedeemTable">
                        <div className="RedeemTableRowHeader">
                          <span style={{ marginLeft: "2%", width: "30%", textAlign: "center" }}>
                            {REDEEM_INFO.REDEEM_INFO_ACE_LEVEL}
                          </span>
                          <span
                           style={{ marginRight: "2%", width: "30%", textAlign: "center" }}
                           className="prizeRight"
                          >
                            {" "}
                            Standard Withdraws
                            <br />
                            per month
                          </span>
                          <span
                            style={{ marginRight: "3%", width: "30%", textAlign: "center" }}
                            className="prizeRight"
                          >
                            {" "}
                            {REDEEM_INFO.REDEEM_INFO_AMOUNT}
                            <br />
                            {REDEEM_INFO.REDEEM_INFO_REQUEST}
                          </span>
                        </div>
                        {redeemInTime.map((listValue, index) => {
                          return (
                            <div
                              className="RedeemTableRow"
                              key={index}
                              style={{
                                borderBottom:
                                  redeemInTime.length == index + 1 && "none",
                                marginRight: "3%",
                              }}
                            >
                              <span className="rowmiddle2">
                                {listValue.aceLevel.charAt(0).toUpperCase() +
                                  listValue.aceLevel.slice(1)}
                              </span>
                              <span className='rowmiddle2'>{listValue.reqPerDay}</span>
                              <span className="rowmiddle2" style={{ marginRight: "3%" }}>
                                ₹ {listValue.maxAmount.toLocaleString()}
                              </span>
                            </div>
                          );
                        })}
                      </div>
                    }

                    <ul className="pl0">
                      {/* commented for new requirement
                       */}
                      {/* <li className="tl fw4 f7 ml3 dark-grey">
                        <p>
                          {" "}
                          At any point no more than 10 redeems are allowed to be
                          in pending state.
                        </p>
                      </li> */}

                      {/* <li className="tl f7 fw4 ml3 dark-grey">
                        <p>
                          To ensure fair play we review every
                          redeem and in case additional checks
                          are required, it may take longer to process.
                        </p>
                      </li> */}

                      <li className="tl fw4 f7 ml3 dark-grey">
                        <p> {REDEEM_INFO.REDEEM_INFO_TEXT4}</p>
                      </li>

                      {/* <li className="tl f7 fw4 ml3 dark-grey">
                        <p>
                          {" "}
                          {REDEEM_INFO.REDEEM_INFO_TEXT5} &nbsp;{" "}
                          <span
                            className="underline blue"
                            onClick={() =>
                              WebToNativeMessage({ type: "email" })
                            }
                          >
                            {REDEEM_INFO.REDEEM_INFO_A23_LINK}
                          </span>
                          &nbsp;{REDEEM_INFO.REDEEM_INFO_LINK_TEXT}
                        </p>
                      </li> */}


                    </ul>
                  </div>
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginTop: "2%",
                      marginBottom: "10px",
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                        height: "95%",
                        border: "1px solid #2C5391",
                        borderRadius: "4px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "#2C5391",
                        fontWeight: "700",
                        minHeight: "45px",
                      }}
                      onClick={() => {
                        WebToNativeMessage({ type: "openContactUs" });
                        WebToNativeMessage({
                          type: "redeemCTEvent",
                          eventName: "PF_c_contactus_pageload",
                          eventProperties: {
                            click_location: "Redeem Policy Page",
                          },
                        });
                      }}
                    >
                      <img
                        src={callUsIcon}
                        alt="contactUs"
                        style={{ height: "35%", marginRight: "2%" }}
                      />{" "}
                      <span>Contact Us</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* )} */}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  userState: state.userState,
});

export default connect(mapStateToProps, {
  toggleModalAction,
  getRedeemDetailsAction,
})(RedeemInfo);

const styles = {
  redeemHeader: {
    width: "100%",
    height: "6%",
    zIndex: "99",
    top: "0",
    position: "fixed",
    background: "#2C5391",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "1rem",
    fontWeight: "700",
    color: "#FFFFFF",
    overflow: "hidden",
  },
};
